export default {
  init() {
    const searchInput = document.querySelector('.ms-search-page__header > input');

    if (!searchInput) { return; }

    this.startSearch(searchInput);
  },
  startSearch($target) {
    const submitBtn = document.querySelector('.ms-search-page__header > button[type="submit"]');

    $target.addEventListener('keydown', (e) => {
      const key = e.key || e.keyCode; // keyCode is deprecated but we'll use it as a fallback
      if ((key === 13 || key === 'Enter') && (e.target.value && e.target.value !== '')) {
        submitSearchQuery(e.target.value);
      }
    });

    // submit button listener
    submitBtn.addEventListener('click', () => {
      if ($target.value && $target.value !== '') {
        submitSearchQuery($target.value);
      }
    });

    const submitSearchQuery = (query) => {
      // important to encode the input to prevent breaking with unescaped characters
      const url = `//${location.host}/search/${encodeURIComponent(query)}`;
      location.href = url;
    }
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/search.js